import { SessionMid } from '@back-office/core';
import { GcpBox, GcpMenuBar, GcpTypography } from '@back-office/ui';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

export interface Store {
  anchorEl: null | HTMLButtonElement;
  merchantName: string;
  clientWidth: number;
  handleOnClick: () => void;
  pick: number;
}

export interface SelectMerchantProps {
  setAuth: (userIndex: number) => void;
}

const SelectMerchant: FC<SelectMerchantProps> = observer((props) => {
  const { t } = useTranslation();
  const { setAuth } = props;
  const { state, users } = useViewModel({ setAuth });

  return (
    <GcpBox isFullWidth>
      <GcpTypography textAlign="center" variant="h3">
        {t('login_form.select_merchant')}
      </GcpTypography>
      <GcpBox mt={3}>
        <GcpMenuBar<SessionMid>
          buttonFullWidth
          anchorEl={state.anchorEl}
          clientWidth={state.clientWidth}
          data={users}
          handleOnClick={(event) => {
            state.anchorEl = event.currentTarget;
            state.clientWidth = event.currentTarget.clientWidth;
          }}
          handleOnClickMenuItem={(selectedItem, index) => {
            if ('merchantName' in selectedItem) {
              state.merchantName = selectedItem.merchantName;
            }
            state.anchorEl = null;
            state.pick = index;
          }}
          handleOnClose={() => {
            state.anchorEl = null;
          }}
          name={state.merchantName}
          selected="merchantName"
        />
      </GcpBox>
      <GcpBox mt={3}>
        <Button
          fullWidth
          color="primary"
          disabled={!state.merchantName}
          size="large"
          variant="contained"
          onClick={state.handleOnClick}
        >
          {t('login_form.next')}
        </Button>
      </GcpBox>
    </GcpBox>
  );
});

export default SelectMerchant;
